import { Alert, Form, Switch } from 'antd';
import React from 'react';

export interface LgChannelVietnamFieldProps {
  /** 계정 단위인지 CP 단위인지 — 경고 문구가 달라진다. */
  scope: 'user' | 'company';
}

const DESCRIPTION: Record<LgChannelVietnamFieldProps['scope'], string> = {
  user: 'Marks this account as LG Channel Vietnam only.',
  company: 'Marks every account in this CP as LG Channel Vietnam only.',
};

/**
 * `is_lg_channel_vietnam` 토글.
 *
 * 표시용 라벨이 아니라 **진입 게이트**다. 켜는 순간 해당 계정은
 * `/api/v1/vietnam-upload/`·`/api/v1/accounts/` 밖의 모든 API가 403이 되고
 * (BE `ScopedJWTAuthentication`), 사이드바도 Vietnam 메뉴로 축소된다.
 * 그래서 토글 옆에 결과를 항상 같이 노출한다 — 모르고 켜면 그 계정이 잠긴다.
 *
 * 실제로 무엇을 할 수 있는지는 이 flag가 아니라 `lg_channel_vietnam` role
 * (= `vietnam-uploads:view` / `:add` / `:ingest`)이 정한다. 둘 다 필요하다.
 *
 * ODK 운영진에게는 켜지 않는다. BE가 admin role을 flag 없이 통과시키므로 불필요하고,
 * 켜면 운영진 사이드바까지 축소된다.
 */
export const LgChannelVietnamField: React.FC<LgChannelVietnamFieldProps> = ({ scope }) => (
  <Form.Item
    name="is_lg_channel_vietnam"
    label="LG Channel Vietnam"
    valuePropName="checked"
    extra={DESCRIPTION[scope]}
  >
    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
  </Form.Item>
);

/** 토글이 켜졌을 때만 뜨는 경고. 폼 안에서 `LgChannelVietnamField` 바로 뒤에 둔다. */
export const LgChannelVietnamWarning: React.FC = () => (
  <Form.Item
    noStyle
    shouldUpdate={(prev, next) => prev.is_lg_channel_vietnam !== next.is_lg_channel_vietnam}
  >
    {({ getFieldValue }) =>
      getFieldValue('is_lg_channel_vietnam') ? (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 24 }}
          message="Everything except Vietnam Video will be blocked"
          description={
            <>
              Once enabled, this account can only see the Vietnam Video menu — every other API call
              returns 403. Do not enable it for ODK staff accounts.
              <br />
              Permissions are separate: assign the <b>lg_channel_vietnam</b> role to grant view /
              upload / ingest.
            </>
          }
        />
      ) : null
    }
  </Form.Item>
);
